import comercio from '../../imgs/comercio.jpg'
import cultivo from '../../imgs/cultivo.jpg'
import vehiculo from '../../imgs/vehiculo.jpg'
import vida from '../../imgs/vida.jpg'
import hogar from '../../imgs/hogar.jpg'

export const items = [
  {
    src: comercio,
    altText: 'Comercio',
    caption: 'Todos los días, el capital que invertís en tu negocio, ya sea de servicios o depósitos y venta de productos, está expuesto a posibles accidentes y pérdidas.',
    header: 'La seguridad de tu empresa no es negociable',
    product: 'comercio'
  },
  {
    src: cultivo,
    altText: 'Rural',
    caption: 'La Póliza Rural de MAPFRE es la solución integral para la explotación agropecuaria, ya que está diseñada especialmente para establecimientos dedicados a este tipo de actividad, así como para viviendas en el medio rural, chacras y quintas.',
    header: 'Sembramos seguridad',
    product: 'rural'
  },
  {
    src: vehiculo,
    altText: 'Automotor',
    caption: 'Una de las especialidades de MAPFRE reside en el ramo de los automóviles. Disponemos de un seguro integral, que incorpora coberturas y servicios exlusivos.',
    header: 'El copiloto que necesitás',
    product: 'automotor'
  },
  {
    src: hogar,
    altText: 'Hogar',
    caption: 'Hoy en día, contar con el Seguro para el Hogar ya no es un privilegio sino una necesidad. La necesidad de estar tranquilo y saber que todo lo que llevás invertido en tu hogar, está protegido. \n Más que asegurado, sentirte seguro. ',
    header: 'Sentirse en casa es sentirse seguro',
    product: 'hogar'
  },
  {
    src: vida,
    altText: 'Vida',
    caption: 'Tu bienestar y el de tu familia es uno de los aspectos que más nos preocupan. Para que puedas disfrutar plenamente y estar prevenido ante cualquier situación que se presente, en MAPFRE contamos con las pólizas de vida, salud y accidentes más completas del mercado. Sólo tienes que elegir la que más se ajuste a ti y a tu entorno.',
    header: 'Vida, Salud y Accidentes',
    product: 'vida'
  },
  
  
]
